import { BaseDialog } from "@/lib/Components/Dialog/BaseDialog";
import { useDialogState } from "@/lib/Components/Dialog/Hooks/useDialogState";
import { GenericForm } from "@/lib/Components/Form/Forms/GenericForm";
import { DialogSubmitButton } from "@/lib/Components/Dialog/Components/DialogSubmitButton";
import { useGqlMutation } from "@/lib/GraphQLCodegen/fetcher";
import { updateWorkOrderAssignment } from "@/app/ProDrivers/WorkOrders/GraphQL/workOrderDriverMutations";
import {
  UpdateWorkOrderAssignmentInput,
  WorkOrderAssignmentFieldsFragment,
} from "@/gql/graphql";
import { WorkOrderAssignmentDetailsForm } from "@/app/ProDrivers/WorkOrders/Components/Forms/WorkOrderAssignmentDetailsForm";

export function UpdateWorkOrderAssignmentDialog({
  assignment,
}: {
  assignment: WorkOrderAssignmentFieldsFragment;
}) {
  const { close, resolve } = useDialogState();
  const { mutateAsync } = useGqlMutation(updateWorkOrderAssignment);

  return (
    <BaseDialog
      title="Assignment Details"
      subtitle="Add movement details for this driver assignment"
    >
      <GenericForm<UpdateWorkOrderAssignmentInput>
        initialValues={{
          pickup_date: assignment.pickup_date,
          pickup_time: assignment.pickup_time,
          delivery_date: assignment.delivery_date,
          delivery_time: assignment.delivery_time,
          booking_reference: assignment.booking_reference,
          driver_notes: assignment.driver_notes,
        }}
        onSubmit={async (values) => {
          await mutateAsync({
            id: assignment.id,
            input: values,
          });

          await close();

          resolve?.({});
        }}
      >
        <WorkOrderAssignmentDetailsForm />
        <DialogSubmitButton text="Save Details" />
      </GenericForm>
    </BaseDialog>
  );
}
